import React from 'react';

import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';

import { requests, get } from '../api';
import { withAppContext } from './AppContext';

const LOGOUT_SAFE_TIME = 60; // second

class SessionInactivity extends React.Component {
    state = {
        countdown: 0,
        dialog: false,
    };
    onRefresh = async () => {
        this.countdownTimer.stop();
        this.setState({ dialog: false });
        await get(this.props.app.settings.urls.status);
    };
    onTimeout = () => {
        this.countdownTimer.start();
        this.setState({ dialog: true });
    };
    onCountdownTimer = countdown => {
        this.setState({ countdown });
        if (countdown <= 0) {
            window.location.href = this.props.app.settings.urls.logout;
        }
    };
    componentDidMount() {
        const sessionTimeout = this.props.app.settings.session.expire;
        const safeTimeout = Math.min(
            LOGOUT_SAFE_TIME,
            Math.floor(sessionTimeout / 2)
        );
        this.countdownTimer = createCountdownTimer(
            this.onCountdownTimer,
            safeTimeout
        );
        this.timer = createTimer(this.onTimeout, sessionTimeout - safeTimeout);
        this.timer.start();
        console.log(`Session(timeout=${sessionTimeout} safe=${safeTimeout})`);

        this.unsubscribe = requests.onResponse(response => {
            if (!this.state.dialog) {
                this.timer.start();
            }
            return response;
        });
    }
    componentWillUnmount() {
        this.timer.stop();
        this.countdownTimer.stop();
        this.unsubscribe();
    }
    render() {
        const { dialog, countdown } = this.state;
        return (
            <ConfirmationDialog
                open={dialog}
                title="Your session is about to end"
                subtitle1={`Your session will end in ${countdown} seconds due to inactivity.`}
                subtitle2="Press OK below to continue working."
                showCancelButton={false}
                onOk={this.onRefresh}
            />
        );
    }
}

function createTimer(callback, timeout) {
    let timer;
    return {
        start() {
            clearTimeout(timer);
            timer = setTimeout(callback, timeout * 1000);
        },
        stop() {
            clearTimeout(timer);
        },
    };
}

function createCountdownTimer(callback, timeout) {
    let timer;
    return {
        start() {
            clearTimeout(timer);
            const start = new Date().getTime();
            let last = 0;
            const next = () => {
                const now = new Date().getTime();
                const end = timeout - Math.floor((now - start) / 1000);
                if (end > 0) {
                    timer = setTimeout(next, 200);
                }
                if (last !== end) {
                    callback(end);
                    last = end;
                }
            };
            timer = setTimeout(next, 200);
        },
        stop() {
            clearTimeout(timer);
        },
    };
}

export default withAppContext(SessionInactivity);
